import React, { useEffect, useState } from "react";
import TableContainer from "../../components/TableContainer/TableContainer";
import { Box, Typography, Select, MenuItem, styled, Button, InputLabel, FormControl, Grid, CircularProgress } from "@mui/material";
import {
  getUserOFACReports,
} from "../../util/API/reporting";
import { debounce } from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { startOfDay, endOfDay, startOfWeek, endOfWeek, startOfMonth, endOfMonth, format, parseISO } from "date-fns";
import { useSelector } from "react-redux";
import BaseButton from "../../components/UI/BaseButton/BaseButton";
import UserReportTable from "../../components/UserReportTable/UserReportTable";
import { setAsArray } from "../../util/utilfunctions/utilFunctions";
import OFACReportTable from "../../components/OFACReportTable/OFACReportTable";

function UserOFACReports() {
  const [duration, setDuration] = useState(1);
  const [showDetails, setShowDetails] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState({
    ofacStatus: "0",
    user: "",
    type: "",
    viewAll: false,
    clearFilter: false
  });
  const [transactionType, setTransactionType] = useState({})
  const [currency, setCurrency] = useState("USD")
  const [options, setOptions] = useState({
    user: [],
    type: [],
    ofacStatus: [
        {
            "key": "0",
            "value": "0",
            "label": "All"
        },
        {
            "key": "1",
            "value": "1",
            "label": "OFAC Flagged"
        },
        {
            "key": "2",
            "value": "2",
            "label": "OFAC Passed"
        }
    ]
  })
  const [fetchSummary, setFetchSummary] = useState(false)
  const [ofacData, setOfacData] = useState([]);
  const [usersCount, setUsersCount] = useState(0);

  let isAdmin = sessionStorage.getItem("isAdmin");
  let isOperator = sessionStorage.getItem("isOperator");
  const requiredConstants = useSelector((state) => state.constants);

    useEffect(()=> {
        getOfacData();
    },[]);

    const getOfacData = async() => {
        // console.log("startDatee-------------", startDate);
        // console.log("endDatee-------------", endDate);
        try {
            setIsLoading(true);
            let start, end;
            const today = new Date();
            
            if (duration == "1") {
                // Daily - today only
                start = startOfDay(today);
                end = endOfDay(today);
            } else if (duration == "2") {
                // Weekly - current week
                start = startOfWeek(today, { weekStartsOn: 1 }); // Monday as first day
                end = endOfWeek(today, { weekStartsOn: 1 });
            } else if (duration == "3") {
                // Monthly - current month
                start = startOfMonth(today);
                end = endOfMonth(today);
            } else {
                // Custom - use selected dates from state
                start = parseISO(startDate);
                end = parseISO(endDate);
            }
            // const formattedStart = format(startOfDay(start), "yyyy-MM-dd");
            // const formattedEnd = format(endOfDay(end), "yyyy-MM-dd");
            const formattedStart = format(startOfDay(start), "yyyy-MM-dd HH:mm:ss");
            const formattedEnd = format(endOfDay(end), "yyyy-MM-dd HH:mm:ss");

            setStartDate(formatDate(start));
            setEndDate(formatDate(end));

            const response = await getUserOFACReports(`${formattedStart} 00:00:00`, `${formattedEnd} 23:59:59`, filter.ofacStatus);
            if(response?.data?.header?.callStatus == "1" && response?.data?.body !== "" ) {
                console.log("getOfacData_response---------",response);
                setUsersCount(response?.data?.header?.reccount);
                setOfacData(setAsArray(response?.data?.body));
            } else {
                setUsersCount(0);
                setOfacData([]);
            }
        } catch (error) {
            console.log("getOfacData_error-----------", error);
        } finally {
            setIsLoading(false);
        }
    }

    let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
    
    const clearFilter = () => {
        setFilter({
            user: "",
            ofacStatus: "0",
            type: "",
            viewAll: false,
            clearFilter: true
        })
        setDuration(1);
        setStartDate(new Date());
        setEndDate(new Date());
    }

    const handleSelectChange = (e) => {
        setFilter({
        ...filter,
        viewAll: false
        })
        setDuration(e.target.value);
        setShowDetails(false);
    };

    const handleDetailSwitch = () => {
        setShowDetails(!showDetails);
    };

    const reportingTitle = {
        1: "Report Daily",
        2: "Report Weekly",
        3: "Report Monthly",
        4: "Report Custom",
    };

    const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
        border: "none",
        color: "#6B7280",
        fontFamily: "Nunito",
        fontSize: "14px",
        fontStyle: "normal",
        lineHeight: "33.6px",
        justifyContent: "left",
    }));

    const StyledDatePicker = styled(DatePicker)({
        borderRadius: "5px", 
        background: "white", 
        width: "120%", 
        height: "40px", 
        "& .MuiInputBase-input": {
        padding: "8px 12px", 
        fontSize: "16px", 
        fontFamily: "Nunito", 
        fontWeight: "600", 
        color: "#6B7280",
        },
        "& .MuiInputLabel-outlined": {
        color: "#6B7280", 
        fontSize: "14px", 
        fontFamily: "Nunito", 
        fontWeight: "400", 
        backgroundColor: "white", 
        padding: "0 5px", 
        },
    });

    const MemoizedDatePicker = React.memo((props) => <StyledDatePicker {...props} />);


    const StyledSelect = styled(Select)({
        borderRadius: "5px", 
        border: "1px solid #D7D7D7", 
        color: "#6B7280",
        fontFamily: "Nunito",
        fontSize: "16px",
        padding: "0px 10px",
        width: "200px",
        height: "40px",
        background: "white", 
        textAlign: "left", 
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
    });

    const StyledInputLabel = styled(InputLabel)({
        color: "#6B7280",
        fontFamily: "Nunito",
        fontSize: "16px",
        background: "white",
        padding: "0 5px",
        lineHeight: "1.2",
        top: "-4px", 
        "&.Mui-focused": {
            color: "#145388",
        },
        "&.MuiInputLabel-shrink": {
            top: "2px"
        },
    });

    // const handleStartDateChange = (dateString) => {
    //     // setStartDate(new Date(dateString));
    //     setStartDate(new Date(dateString).setHours(0, 0, 0, 0));

    //     // Optional: ensure startDate is not after endDate
    //     // if (new Date(dateString) > new Date(endDate)) {
    //     //     setEndDate(new Date(dateString)); // Adjust end date to match start
    //     // }
    // };

    // const handleEndDateChange = (dateString) => {
    //     // setEndDate(new Date(dateString));
    //     setEndDate(new Date(dateString).setHours(23, 59, 59, 999));
        
    //     // Optional: ensure endDate is not before startDate
    //     // if (new Date(dateString) < new Date(startDate)) {
    //     //     setStartDate(new Date(dateString)); // Adjust start date to match end
    //     // }
    // };

    const handleStartDateChange = (dateString) => {
        console.log("handleStartDateChange======",dateString);
        const newStartDate = parseISO(dateString);
        // console.log("newStartDate============",newStartDate);
        setStartDate(formatDate(newStartDate));
        // const date = new Date(dateString);
        // date.setHours(0, 0, 0, 0); // normalize to start of day
        // setStartDate(date);
    };

    const handleEndDateChange = (dateString) => {
        console.log("handleEndDateChange======",dateString);
        const newEndDate = parseISO(dateString);
        setEndDate(formatDate(newEndDate));
        // const date = new Date(dateString);
        // date.setHours(23, 59, 59, 999); // normalize to end of day
        // setEndDate(date);
    };

    // const formatDate = (date) => {
    //     console.log(date)
    //     if (!date) return ""; 
    //     let d = date instanceof Date ? date : new Date(`${date}T00:00`);
    //     console.log(d)
    //     const year = d.getFullYear();
    //     const month = d.getMonth() + 1; 
    //     const day = d.getDate(); 
    
    //     console.log(`${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`)
      
    //     return `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;
    // };

    const formatDate = (date) => {
        console.log(date)
        if (!date) return ""; 
        let d = date instanceof Date ? date : new Date(`${date}T00:00`);
        console.log(d)
        const year = d.getFullYear();
        const month = d.getMonth() + 1; 
        const day = d.getDate(); 
    
        console.log(`${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`)
      
        return `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;
      };

    return (
        <Box className="page-container">
            {isLoading == true ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                    }}
                >
                    <CircularProgress />
                </Box>
        ) : (
            <>
                <Box className="header-container">
                    <Box className={`page-title`}>
                    User OFAC Report
                    </Box>
                </Box>
                <Box className="batch-tabs">

                    <Box sx={{ backgroundColor: "#FFFFFF", padding: "10px", borderRadius: "8px" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "nowrap" }}>
                        <Box sx={{ marginRight: "auto"}}>
                            <FormControl fullWidth>
                            <InputLabel
                                id="select-view-label"
                                sx={{
                                color: "#6B7280",
                                fontFamily: "Nunito",
                                fontSize: "16px",
                                background: "white",
                                padding: "0 5px",
                                }}
                            >
                                Select Duration
                            </InputLabel>
                            <Select
                                labelId="select-view-label"
                                name="selectView"
                                className="reporting-select"
                                onChange={handleSelectChange}
                                value={duration}
                                sx={{
                                borderRadius: "5px", // Custom border radius
                                border: "1px solid #D7D7D7", // Your custom border
                                color: "#6B7280", // Text color
                                fontFamily: "Nunito", // Font family
                                fontSize: "16px", // Font size
                                padding: "0px 10px", // Adjust padding
                                width: "100%", // Width
                                height: "40px", // Height
                                background: "white", // Background color
                                textAlign: "left", // Align text to the left
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none", // Removes the default border applied by Material-UI
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none", // Ensures no border appears on hover
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    border: "none", // Ensures no border appears on focus
                                },
                                }}
                            >
                                <CustomMenuItem value="" disabled>
                                Reports
                                </CustomMenuItem>
                                <CustomMenuItem value="1">Daily</CustomMenuItem>
                                <CustomMenuItem value="2">Weekly</CustomMenuItem>
                                <CustomMenuItem value="3">Monthly</CustomMenuItem>
                                <CustomMenuItem value="4">Custom</CustomMenuItem>
                            </Select>
                            </FormControl>
                        </Box>
                        {/* User */}
                        <Box sx={{ display: "flex", alignItems: "center", width: "200px" }}>
                            <FormControl fullWidth>
                            <StyledInputLabel
                            id="user-label"
                            sx={{
                                color: "#6B7280",
                                fontFamily: "Nunito",
                                fontSize: "16px",
                                background: "white",
                                padding: "0 5px",
                                lineHeight: "1.2", 
                                top: "-4px", 
                                "&.Mui-focused": { color: "#145388" },
                                "&.MuiInputLabel-shrink": { top: "2px" },
                            }}
                            >
                            OFAC Status
                            </StyledInputLabel>
                            <StyledSelect
                            labelId="user-label"
                            name="ofacStatus"
                            className="reporting-select"
                            onChange={(e) => {setFilter({ ...filter, ofacStatus: e.target.value })}}
                            value={filter?.ofacStatus} 
                            // value={filter?.user || options?.ofacStatus[0]?.value} 
                            fullWidth
                            >
                            <CustomMenuItem value="">
                                Select OFAC status
                            </CustomMenuItem>
                            {options.ofacStatus.map((option) => (
                                <CustomMenuItem key={option.key} value={option.value}>
                                {option.label}
                                </CustomMenuItem>
                            ))}
                            </StyledSelect>
                        </FormControl>
                        </Box>

                        {/* From Date */}
                        <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MemoizedDatePicker
                                label="From"
                                disabled={duration !== "4"}
                                value={parseISO(startDate) || null} 
                                onChange={(newDate) => {
                                    if (newDate && !isNaN(newDate)) {
                                        handleStartDateChange(format(newDate, "yyyy-MM-dd"))
                                    }
                                }}
                                inputFormat="yyyy-MM-dd" 
                                InputLabelProps={{ shrink: true }}
                            />
                            </LocalizationProvider>
                        </Box>

                        {/* To Date */}
                        <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MemoizedDatePicker
                                label="To"
                                disabled={duration !== "4"}
                                value={parseISO(endDate) || null} 
                                onChange={(newDate) => {
                                if (newDate && !isNaN(newDate)) {
                                    handleEndDateChange(format(newDate, "yyyy-MM-dd"))
                                }
                                }}
                                inputFormat="yyyy-MM-dd"
                                InputLabelProps={{ shrink: true }}
                            />
                            </LocalizationProvider>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <BaseButton
                            buttonText="Run Report"
                            sx={{
                                height: "40px",
                                minWidth: "120px",
                                padding: "5px 15px",
                                fontSize: "14px",
                                lineHeight: "normal", 
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "15px",
                                textTransform: "none",
                            }}
                            onClick={() => {
                                // setFetchSummary(true);
                                // setShowDetails(false);
                                getOfacData();
                            }}
                            />

                            <Button
                            variant="outlined"
                            sx={{
                                textTransform: "none",
                                fontSize: "14px",
                                color: "#6B7280",
                                borderColor: "#D7D7D7",
                                borderRadius: "5px",
                                padding: "5px 15px",
                                height: "40px",
                                "&:hover": {
                                backgroundColor: "#F5F5F5",
                                borderColor: "#D7D7D7",
                                },
                            }}
                            onClick={clearFilter}
                            >
                            Clear Filter
                            </Button>
                        </Box>
                        </Box>
                    </Box>

                
                    <Box className="reporting-container">
                        <Box className="reporting-table-header">
                            {`${reportingTitle[duration]} - ${usersCount} (${filter.ofacStatus == "1" ? "OFAC Flagged Users" : filter.ofacStatus == "2" ? "OFAC Passed Users" : "All Users" })`}
                        </Box>
                        <OFACReportTable
                            ofacData={ofacData}
                            handleSelectedUser={null}
                            targetID={null}
                            systemRoles={[]}
                            ofacStatus={null}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </Box>
                </Box>
            </>
        )}
        </Box>
    );
}

export default UserOFACReports;
